import { Desktop, MobileOrTablet } from "../media-queries";
import DesktopFooter from "./desktop";
import MobileFooter from "./mobile";

function Footer(){
    return <footer>
        <Desktop>
            <DesktopFooter/>
        </Desktop>
        <MobileOrTablet>
            <MobileFooter/>
        </MobileOrTablet>
    </footer>
}

export default Footer;